import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

import BrandOwner from 'components/brandListItem/components/BrandOwner';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'center',
    },
  },
  owner: {
    width: '33.3333%',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]: {
      width: '50%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      maxWidth: '400px',
    },
  },
}));

const Owners = ({ owners, user, brandId, expired }) => {
  const classes = useStyles();

  const renderOwners = (owner) => {
    const { id, ownedByLoggedInUser } = owner;

    return (
      <div key={id} className={classes.owner}>
        <BrandOwner
          reloadDisplayedBrands={() => { }}
          user={user}
          expired={expired}
          owner={owner}
          ownedByLoggedInUser={ownedByLoggedInUser}
          brandId={brandId}
        />
      </div>
    );
  };

  return (
    <div className={classes.wrapper}>
      {owners.map(renderOwners)}
    </div>
  );
};

Owners.propTypes = {
  brandId: PropTypes.number.isRequired,
  owners: PropTypes.arrayOf(Object).isRequired,
  user: PropTypes.object.isRequired,
};

export default Owners;
